import React from "react";
import { Box, TextField, IconButton } from "@mui/material";
import { RemoveCircle } from "@mui/icons-material";
import produce from "immer";

interface ScriptParameter {
  key: string;
  value: string;
}

interface ScriptParametersProps {
  scriptParameters: ScriptParameter[];
  setScriptParameters: React.Dispatch<React.SetStateAction<ScriptParameter[]>>;
}

const ScriptParameters: React.FC<ScriptParametersProps> = ({ scriptParameters, setScriptParameters }) => {
  return (
    <Box sx={{ overflow: "auto", display: "flex", flexDirection: "column" }}>
      {scriptParameters.map((scriptParameter, index) => (
        <Box key={index} sx={{ display: "flex", gap: 1, mt: 1 }}>
          <TextField
            label="Name"
            value={scriptParameter.key}
            onChange={(evt) => {
              setScriptParameters(
                produce((draft) => {
                  const scriptParameter = draft[index];

                  if (scriptParameter !== undefined) {
                    scriptParameter.key = evt.target.value;
                  }
                })
              );
            }}
          />
          <TextField
            label="Value"
            value={scriptParameter.value}
            onChange={(evt) => {
              setScriptParameters(
                produce((draft) => {
                  const scriptParameter = draft[index];

                  if (scriptParameter !== undefined) {
                    scriptParameter.value = evt.target.value;
                  }
                })
              );
            }}
          />
          <IconButton
            size="small"
            onClick={() =>
              setScriptParameters(
                produce((draft) => {
                  draft.splice(index, 1);
                })
              )
            }>
            <RemoveCircle />
          </IconButton>
        </Box>
      ))}
    </Box>
  );
};

export default ScriptParameters;
